import PropTypes from 'prop-types';
import React, { Component } from 'react';
import isString from 'lodash/isString';
import uniqueId from 'lodash/uniqueId';
import isFunction from 'lodash/isFunction';
import eqProps from 'ramda/src/eqProps';
import pipe from 'ramda/src/pipe';
import path from 'ramda/src/path';
import { t } from '../../../modules/infra/i18n';

import withLoadImage from '../hoc/withLoadImage';

class UploadPhotoInput extends Component {
  static propTypes = {
    loadAndResizeImage: PropTypes.func.isRequired,
    fileContents: PropTypes.string.isRequired,
    setFileContents: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired,
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      onContentChange: PropTypes.func,
      value: PropTypes.any,
    }).isRequired,
    className: PropTypes.string,
    maxWidth: PropTypes.number,
    loading: PropTypes.bool,
    checkInitialValue: PropTypes.bool,
  };
  static defaultProps = {
    className: '',
    maxWidth: 3000,
    loading: false,
    checkInitialValue: false,
  };

  state = { fileContents: null };

  componentDidMount() {
    if (this.props.checkInitialValue && this.props.input.value instanceof File && !this.props.fileContents) {
      const reader = new FileReader();

      reader.onloadend = () => {
        this.props.setFileContents(reader.result);
      };

      reader.readAsDataURL(this.props.input.value);
    }
  }

  componentDidUpdate(prevProps) {
    const hasOnContentChange = pipe(
      path(['props', 'input', 'onContentChange']),
      isFunction
    )(this);
    if (!eqProps('fileContents', this.props, prevProps) && hasOnContentChange) {
      this.props.input.onContentChange(this.props.fileContents);
    }
  }

  inputId = uniqueId('photoinput');

  handleChange = async (e) => {
    e.preventDefault();
    const files = e.target.files;
    if (!files.length) {
      return false;
    }

    const file = await this.props.loadAndResizeImage(files[0], this.props.maxWidth);
    return this.props.input.onChange(file);
  };

  render() {
    const {
      fileContents,
      className,
      input: { value },
      loading,
    } = this.props;
    const imageUrl = isString(value) ? value : fileContents;
    return (
      <label className={className} htmlFor={this.inputId}>
        <input type="file" accept="image/*" onChange={this.handleChange} id={this.inputId} hidden />
        {
          loading
            ? <small>{t('common:upload_photo.loading_text')}</small>
            : (this.props.children && this.props.children(imageUrl))
        }
      </label>
    );
  }
}

export default withLoadImage(UploadPhotoInput);
